var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { propChildren, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import { useScrollLock } from '../../../../helpers/use/useScrollLock';
import ModalHoc from '../ModalHoc';
import ModalPortalHoc from '../ModalPortalHoc';
const FullScreenModal = (props) => {
    const { className, hideFullModal, modalState } = props;
    const { children } = props, otherProp = __rest(props, ["children"]);
    const scrollLockRef = useScrollLock();
    return (_jsxs("div", Object.assign({ className: `full_screen_modal animated-opacity ${className} ${modalState}`, ref: scrollLockRef }, { children: [_jsx("div", Object.assign({ className: 'full_screen_modal_body' }, { children: cloneElement(children, Object.assign({}, otherProp)) })), _jsx("button", Object.assign({ className: 'full_screen_modal_close', onClick: hideFullModal, type: 'button' }, { children: _jsx("i", { className: 'material-icons close_icon' }) }))] })));
};
FullScreenModal.propTypes = {
    children: propChildren().isRequired,
    className: propStr(),
    hideFullModal: propFunc().isRequired,
    modalState: propStr().isRequired,
};
FullScreenModal.defaultProps = {
    className: '',
};
const enhance = compose(ModalPortalHoc({ selector: '#app' }), ModalHoc);
export default enhance(FullScreenModal);
